export class PostPedidosResumoVarios {
    constructor (
        public pedidosIds: string[] = []
    ) {}
}